import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type IncidentWorkOrderOption = ResultOf<
  typeof incidentWorkOrderOptionsQuery
>["workOrders"]["data"][number];

graphql(`
  fragment IncidentWorkOrderOptionFields on WorkOrder {
    id
    reference
    currency
    supplier {
      id
      name
    }
    departureAddress {
      id
      city
    }
    deliveryAddress {
      id
      city
    }
    assignments {
      id
      driver_delivered_at
      proDriver {
        id
        name
      }
    }
  }
`);

export const incidentWorkOrderOptionsQuery = graphql(`
  query IncidentWorkOrderOptions($search: String, $page: Int!, $first: Int!) {
    workOrders(search: $search, page: $page, first: $first) {
      data {
        ...IncidentWorkOrderOptionFields
      }
    }
  }
`);
